import angular from 'angular';
import uiRouter from 'angular-ui-router';
import drgsComponent from './drgs.component';

let drgsModule = angular.module('drgs', [
  uiRouter
])

.component('drgs', drgsComponent);

export default drgsModule;



// WEBPACK FOOTER //
// ./client/app/common/admin/drgs/drgs.js